import { appMetadataFetchers } from "./app-metadata";
import { feedbackFetchers } from "./feedback";
import { aiGatewayFetchers } from "./ai-gateway";
import { foldersFetchers } from "./folders";
import { notesFetchers } from "./notes";
import { profilesFetchers } from "./profiles";
import { storageFetchers } from "./images";
import { stripeFetchers } from "./subscription";
import { tagsFetchers } from "./tags";
import { todosFetchers } from "./todos";
import { userSettingsFetchers } from "./user-settings";
import { vaultKeysFetchers } from "./vault-keys";
import { dailyUserStatsFetchers } from "./daily-user-stats";

export const fetchers = {
  aiGateway: aiGatewayFetchers,
  appMetadata: appMetadataFetchers,
  dailyUserStats: dailyUserStatsFetchers,
  folders: foldersFetchers,
  notes: notesFetchers,
  profiles: profilesFetchers,
  feedback: feedbackFetchers,
  storage: storageFetchers,
  stripe: stripeFetchers,
  tags: tagsFetchers,
  todos: todosFetchers,
  userSettings: userSettingsFetchers,
  vaultKeys: vaultKeysFetchers,
};
